import React, { Component } from "react";
import PropTypes from "prop-types";
import placeholderImage from "../../images/forms/placeholderImage.png";
import _ from "lodash";

class SentListItem extends Component {
  constructor(props) {
    super(props);
    this.touchableInactive = false;
  }

  handleClick(icon_path, e) {
    if (!this.touchableInactive) {
      this.touchableInactive = true;
      setTimeout(() => {
        this.touchableInactive = false;
      }, 1500);

      this.props.onClick(
        this.props.result_id,
        this.props.form_title,
        this.props.form_version,
        this.props.date_added,
        this.props.form_id,
        icon_path
      );
    }
  }

  renderStatus() {
    if (this.props.approval_enabled) {
      switch (this.props.status) {
        case 1:
          return (
            <span
              style={{
                fontSize: 12,
                marginLeft: 10,
                paddingRight: 4,
                paddingLeft: 4,
                borderRadius: 4,
                textAlignVertical: "center",
                padding: 2,
                backgroundColor: "orange",
                color: "white"
              }}
            >
              Pending
            </span>
          );
        case 2:
          return (
            <span
              style={{
                fontSize: 12,
                marginLeft: 10,
                paddingRight: 4,
                paddingLeft: 4,
                borderRadius: 4,
                textAlignVertical: "center",
                padding: 2,
                backgroundColor: "red",
                color: "white"
              }}
            >
              Rejected
            </span>
          );
        case 3:
          return (
            <span
              style={{
                fontSize: 12,
                marginLeft: 10,
                paddingRight: 4,
                paddingLeft: 4,
                borderRadius: 4,
                textAlignVertical: "center",
                padding: 2,
                backgroundColor: "green",
                color: "white"
              }}
            >
              Approved
            </span>
          );
        default:
          return null;
      }
    } else {
      return null;
    }
  }

  renderImage(icon_path) {
    const { form_title, form_version, date_added, user_name } = this.props;

    let t = date_added.substring(date_added.indexOf("T") + 1);
    t = t.substring(0, t.indexOf("+"));
    let dt = date_added.substring(0, date_added.indexOf("T")) + " " + t;
    let titleText = form_title;
    let i = 0;

    if (icon_path === "" || icon_path === null) {
      return (
        <div style={{ flex: 1, position: "relative", flexDirection: "row" }}>
          <div style={{ float: "left" }}>
            <img width={55} src={placeholderImage} />
          </div>
          <div style={{ marginLeft: 65, flexDirection: "column" }}>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 16,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: this.props.storeColour.mainBgColor
                }}
              >
                {titleText}
              </span>
            </div>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 14,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: "grey"
                }}
              >
                {user_name}
              </span>
            </div>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 12,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: "darkgrey"
                }}
              >
                {"v" + form_version + " | " + dt}
              </span>
              {this.renderStatus()}
            </div>
          </div>
          <div
            style={{
              float: "right",
              position: "absolute",
              top: 23,
              right: 20,
              justifyContent: "center"
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                class="ffff"
                d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
              />
              <path fill="none" d="M0 0h24v24H0V0z" />
            </svg>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ flex: 1, position: "relative", flexDirection: "row" }}>
          <div style={{ float: "left" }}>
            <img width={55} src={icon_path} />
          </div>
          <div style={{ marginLeft: 65, flexDirection: "column" }}>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 16,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: this.props.storeColour.mainBgColor
                }}
              >
                {titleText}
              </span>
            </div>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 14,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: "grey"
                }}
              >
                {user_name}
              </span>
            </div>
            <div style={{ flexDirection: "row" }}>
              <span
                style={{
                  fontSize: 12,
                  paddingLeft: 20,
                  textAlignVertical: "center",
                  padding: 2,
                  color: "darkgrey"
                }}
              >
                {"v" + form_version + " | " + dt}
              </span>
              {this.renderStatus()}
            </div>
          </div>
          <div
            style={{
              float: "right",
              position: "absolute",
              top: 23,
              right: 20,
              justifyContent: "center"
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                class="ffff"
                d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
              />
              <path fill="none" d="M0 0h24v24H0V0z" />
            </svg>
          </div>
        </div>
      );
    }
  }

  renderBlock(icon_path) {
    if (this.props.completed === "1") {
      return (
        <div style={{ flexDirection: "row" }}>
          <div style={{ paddingBottom: 0, flex: 1, paddingLeft: 10 }}>
            {this.renderImage()}
          </div>
        </div>
      );
    }

    return (
      <div style={{ flexDirection: "row" }}>
        <div style={{ paddingBottom: 0, flex: 1, paddingLeft: 10 }}>
          {this.renderImage(icon_path)}
        </div>
      </div>
    );
  }

  render() {
    let form_id = this.props.form_id;

    let currentForm = _.filter(this.props.forms, function(data) {
      return Number(data.form_id) === Number(form_id);
    });

    let icon_path = "";
    if (currentForm.length > 0) {
      icon_path = currentForm[0].icon_path;
    }

    return (
      <div
        onClick={this.handleClick.bind(this, icon_path)}
        style={{
          paddingTop: 10,
          paddingBottom: 20,
          width: "100%",
          cursor: "pointer",
          alignItems: "center"
        }}
      >
        {this.renderBlock(icon_path)}
      </div>
    );
  }
}

SentListItem.propTypes = {
  icon_path: PropTypes.string,
  form_title: PropTypes.string.isRequired,
  form_version: PropTypes.string.isRequired,
  form_id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  forms: PropTypes.array,
  container: PropTypes.string.isRequired,
  saved: PropTypes.bool,
  completed: PropTypes.bool,
  width: PropTypes.number.isRequired,
  storeColour: PropTypes.object.isRequired
};

export default SentListItem;



// WEBPACK FOOTER //
// ./src/components/SentListItem/index.js